module.exports = [{id: 'self'}, {id: 'retailer'}];
